
export const normalizeEntryDate = (entry: { year?: number | null; month?: number | null; day?: number | null; date?: string | null }): Date => {
  // Handle entries with year, month, and day
  if (entry.year && entry.month && entry.day) {
    return new Date(entry.year, entry.month - 1, entry.day);
  }
  
  // Handle entries with year and month only (treat as 1st of month)
  if (entry.year && entry.month) {
    return new Date(entry.year, entry.month - 1, 1);
  }
  
  // Handle entries with year only (treat as Jan 1st)
  if (entry.year) {
    return new Date(entry.year, 0, 1);
  }
  
  // Handle entries with date field
  if (entry.date) {
    return new Date(entry.date);
  }
  
  // Fallback for entries without proper date info
  return new Date(0);
};

export const sortEntriesAscending = <T extends { year?: number | null; month?: number | null; day?: number | null; date?: string | null }>(entries: T[]): T[] => {
  return [...entries].sort((a, b) => {
    const dateA = normalizeEntryDate(a);
    const dateB = normalizeEntryDate(b);
    return dateA.getTime() - dateB.getTime();
  });
};

/**
 * Formats a Date object to YYYY-MM-DD string without timezone conversion.
 * This prevents the "birthday saved 1 day earlier" issue that occurs when
 * using toISOString().split('T')[0] which converts to UTC timezone first.
 */
export const formatDateForDatabase = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
